export default "__VITE_ASSET__qUa0kjlJ__"